<template>
    <div class="results-selection-wrapper">
        <label class="results-selection select-all-results" :class="{ 'disabled' : !lessThan500 }">
            <span class="facet-name">{{ $t("labels.select_all_results") }}</span>
            <input
                ref="selectAll"
                :class="{'checked': selectedAll}"
                type="checkbox" 
                name="results-selection" 
                value="all"
                :disabled="!lessThan500" 
                @click="selectAll">
        </label> 
        <label class="results-selection select-all-on-page">
            <span class="facet-name">{{ $t("labels.select_all_page") }}</span>
            <input 
                ref="selectPage"
                :class="{'checked': selectedPage}"
                type="checkbox" 
                name="results-selection" 
                value="on-page"
                @click="selectPage">
        </label> 
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "MultiSelect",
    data () {
        return {
            selectedAll: false,
            selectedPage: false,
        }
    },
	computed: {
		...mapGetters({
            results: "results/list_results",
            list: "results/traversal_list",
            saved_items: "list/saved_items",
            'saved_ids': 'list/saved_ids',
            'selected_ids': 'list/selected',
            'search_type': 'results/type',
            'archive_count': 'results/archive_count',
            'artifact_count': 'results/artifact_count',
            'all_count': 'results/all_count',
		}),
        lessThan500 () {
            if (this.itemType == 'results') {
                return this.typeTotalResults < 500;
            } else {
                return true;
            }
        },
        typeTotalResults () {
             let countMap = {
                archive: this.archive_count,
                artifact: this.artifact_count,
                all: this.all_count,
            }

            return countMap[this.search_type];
        }
	},
    props: {
        itemType: String,
    },
    watch: {
        'results' () {
            this.clearInputs()
        },
        'selected_ids' () {
            if (this.selected_ids.length == 0) {
                this.clearInputs()
            }
        },
    },
    methods: {
        clearInputs(){
            this.selectedPage = false;
            this.selectedAll = false;
            if (this.$refs.selectAll) this.$refs.selectAll.checked = false;
            if (this.$refs.selectPage) this.$refs.selectPage.checked = false;
        },
        selectPage() {
            if (this.$refs.selectAll) this.$refs.selectAll.checked = false;
            if (this.$refs.selectPage.checked) {
                if (this.selectedAll) {
                    this.$store.dispatch('list/clearSelected')
                    this.selectedAll = false;
                }
                this.selectedPage = true;

                if (this.itemType == 'results') {

                    if (this.saved_ids.length >= 500) {
                        let msg =  this.$i18n.messages[this.$i18n.locale].overlimit_modal.hit_limit
                        this.$store.dispatch('list/showModal', {
                            display: true,
                            msg: msg
                        })
                        this.selectedPage = false;
                        this.$refs.selectPage.checked = false;
                        return;
                    } else if (this.saved_ids.length + this.results.results.length > 500) {
                        let msg =  this.$i18n.messages[this.$i18n.locale].overlimit_modal.page
                        this.$store.dispatch('list/showModal', {
                            display: true,
                            msg: msg
                        })
                        this.selectedPage = false;
                        this.$refs.selectPage.checked = false;
                        return;
                    }
                
                    this.results.results.forEach(r => {
                        if (!this.saved_ids.includes(r.id) && !this.selected_ids.includes(r.id)) {
                            this.$store.dispatch('list/stageItem', r.id)
                        }
                    })

                    if (this.selected_ids.length == 0) {
                        let msg =  this.$i18n.messages[this.$i18n.locale].already_selected_modal.page
                        this.$store.dispatch('list/showModal', {
                            display: true,
                            msg: msg
                        })
                    }
                } else { 
                    this.saved_items.forEach(r => {
                        if (this.saved_ids.includes(r.id) && !this.selected_ids.includes(r.id)) {
                            this.$store.dispatch('list/stageItem', r.id)
                        }
                    })
                }
            } else {
                this.$store.dispatch('list/clearSelected')
                this.$refs.selectPage.checked = false;
                this.selectedPage = false;
            }
        },
        async selectAll() {
            this.selectedPage = false;
            this.$refs.selectPage.checked = false;
            if (this.$refs.selectAll.checked) {
                this.selectedAll = true;

                if (this.itemType == 'results') {
                    if (this.saved_ids.length >= 500) {
                        let msg =  this.$i18n.messages[this.$i18n.locale].overlimit_modal.hit_limit
                        this.$store.dispatch('list/showModal', {
                            display: true,
                            msg: msg
                        })
                        this.selectedAll = false;
                        this.$refs.selectAll.checked = false;
                        return;
                    } else if (this.results.count + this.saved_ids.length > 500) {
                        let msg =  this.$i18n.messages[this.$i18n.locale].overlimit_modal.all
                        this.$store.dispatch('list/showModal', {
                            display: true,
                            msg: msg
                        })
                        this.$refs.selectAll.checked = false;
                        this.selectedAll = false;
                        return;
                    }

                    await this.$store.dispatch('list/selectAllResults')

                    if (this.selected_ids.length == 0) {
                        let msg =  this.$i18n.messages[this.$i18n.locale].already_selected_modal.all
                        this.$store.dispatch('list/showModal', {
                            display: true,  
                            msg: msg
                        })
                    }
                } else { 
                    this.$store.dispatch('list/selectAllSaved')
                }
            } else {
                this.$store.dispatch('list/clearSelected')
                this.$refs.selectAll.checked = false;
                this.selectedAll = false;
            }
        },
    }
};
</script>

<style scoped lang="scss">
    .results-selection-wrapper{
        width: 100%;
        flex-direction: column;
    }
    // .n-ml .results-selection{
    //    margin-left: -1.25rem;
    // }
    .label-mr .results-selection .facet-name{
        margin-right: 0.625rem;
    }
    .saved-list .results-selection:last-child{
        margin-bottom: 0;
    }
    .results-selection{
        margin-bottom: 1.063rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: $futuraBold;
        font-style: normal;
        font-weight: 700;
        font-size: 0.875rem;
        text-transform: uppercase;
        color: $dark-gray2;

        input {
            flex-shrink: 0;
            width: 1.3em;
            height: 1.3em;
            background-color: $white;
            border-radius: 50%;
            vertical-align: middle;
            border: 2px solid $menu-gray;
            appearance: none;
            -webkit-appearance: none;
            outline: none;
            cursor: pointer;

            &.checked, &:checked {
                background-color: $menu-gray;
            }
            &:disabled {
                opacity: .75;
                cursor: default;
            }
        }
        &.disabled {
            opacity: .75;
        }
    }
    @media (max-width: $mq-max-width-tablet) {
        .n-ml .results-selection{
            margin-left: 0;
        }
        .results-selection{
            width: auto;
        }
    }
</style>
